import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, { Optional, Silent } from "@/__main__/data-model.mjs";
import RoleSymbol from "@/game-lol/utils/symbol-role.mjs";

export const model = {
  accountId: Silent(String),
  assists: Number,
  boots: [{ id: String }],
  buildPaths: [{ id: String, itemId: Number, timestamp: Number }],
  champion: Number,
  deaths: Number,
  encryptedAccountId: Silent(String),
  gameDuration: Number,
  gold: Number,
  id: String,
  insertedAt: String,
  items: [{ id: String }],
  kills: Number,
  lane: String,
  opponentChampion: Number,
  patch: String,
  player: {
    id: String,
    fame: Silent(Number),
    accounts: [String],
    insertedAt: String,
    name: String,
    portraitImageUrl: Silent(String),
    profileImageUrl: Silent(String),
    realName: Silent(String),
    region: String,
    slug: String,
    team: {
      id: String,
      insertedAt: String,
      name: String,
      pictureUrl: String,
      region: String,
      tag: String,
      updatedAt: String,
    },
    teamId: Silent(String),
    updatedAt: String,
  },
  tournamentSummonerName: Optional(String),
  tournamentTeam: Optional(String),
  tournamentOpponentTeam: Optional(String),
  tournamentType: Optional(String),
  playerId: String,
  region: String,
  riotMatchId: Silent(String),
  role: RoleSymbol,
  runePrimaryTree: Number,
  runeSecondaryTree: Number,
  runeShards: [Number],
  runes: [{ id: String }],
  skillOrder: [
    {
      id: String,
      skillSlot: Number,
      timestamp: Number,
    },
  ],
  spells: [{ ids: [String] }],
  timestamp: String,
  updatedAt: String,
  win: Boolean,
} satisfies ModelDefinition;

const LolCompetitiveMatchesModel = createModel({
  data: {
    probuildsCompetitiveMatches: [model],
  },
}).transform([model], (data) => data.data.probuildsCompetitiveMatches);

export type LolCompetitiveMatches = FromModel<
  typeof LolCompetitiveMatchesModel
>;

export default LolCompetitiveMatchesModel;
